const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function pad(value) {
  return `${value}`.padStart(2, "0");
}

function parseDateOnly(value) {
  if (!DATE_ONLY.test(`${value || ""}`)) {
    return null;
  }

  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}

function formatDateOnly(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function addDays(date, days) {
  const result = new Date(date.getTime());
  result.setDate(result.getDate() + days);
  return result;
}

function dayDistance(start, end) {
  const cursor = new Date(start.getTime());
  let count = 0;

  while (cursor < end) {
    cursor.setDate(cursor.getDate() + 1);
    count += 1;
  }

  return count;
}

export function calendarErrorDetails(error) {
  const response = error?.jqXHR?.responseJSON || error?.responseJSON || {};

  return {
    type: response.error_type || "",
    limit: Number(response.limit) || null,
  };
}

export function isCalendarWorkLimitError(error) {
  return calendarErrorDetails(error).type === "calendar_too_large";
}

export function calendarEventIdentity(event) {
  return [
    event?.id,
    event?.occurrence_id || "",
    event?.occurrence_key || "",
    event?.starts_at || "",
  ].join(":");
}

export function mergeCalendarEvents(existingEvents, incomingEvents) {
  const merged = [];
  const seen = new Set();

  [...asArray(existingEvents), ...asArray(incomingEvents)].forEach((event) => {
    const key = calendarEventIdentity(event);
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    merged.push(event);
  });

  return merged;
}

export function buildCalendarDateBatches(startValue, endValue, batchDays = 7) {
  const start = parseDateOnly(startValue);
  const end = parseDateOnly(endValue);
  const safeBatchDays = Math.max(1, Number(batchDays) || 1);

  if (!start || !end || end <= start) {
    return [];
  }

  const batches = [];
  let cursor = start;

  while (cursor < end) {
    const proposedEnd = addDays(cursor, safeBatchDays);
    const batchEnd = proposedEnd < end ? proposedEnd : end;
    batches.push({
      start: formatDateOnly(cursor),
      end: formatDateOnly(batchEnd),
      days: dayDistance(cursor, batchEnd),
    });
    cursor = batchEnd;
  }

  return batches;
}

export function splitCalendarDateBatch(batch) {
  const start = parseDateOnly(batch?.start);
  const end = parseDateOnly(batch?.end);

  if (!start || !end) {
    return [];
  }

  const days = dayDistance(start, end);
  if (days <= 1) {
    return [];
  }

  const split = addDays(start, Math.ceil(days / 2));

  return [
    {
      start: formatDateOnly(start),
      end: formatDateOnly(split),
      days: dayDistance(start, split),
    },
    {
      start: formatDateOnly(split),
      end: formatDateOnly(end),
      days: dayDistance(split, end),
    },
  ];
}
